import React from 'react'
import { useTransition, animated,useSpring } from '@react-spring/web'
import { useLayoutEffect ,useState} from 'react';

//a ne pas laisser
import Timeline from 'views/Timeline'
import Landing from 'views/Landing'
import BrandLogo from 'components/BrandLogo'
import LandscapeModal from 'components/LandscapeModal'

import { useApp } from 'store/AppStore'
import { Root } from './App.styled'
import { useIdleTimer } from 'react-idle-timer'

import ReactGA from 'react-ga4';
const TRACKING_ID = "G-BLH2K8YKF8";
ReactGA.initialize(TRACKING_ID, {
  debug: true,
  titleCase: false,
  gaOptions: {
    userId: 123
  }
});
//ReactGA.pageview(window.location.pathname + window.location.search);

window.utalk = new Object();
var scenarioid = "29568aea-57b2-4594-89ba-575fe5bbb801"; //scenario pour le nodeJS
window.utalk.imgqr = ""; //Variable vide pour l'image QRcode
window.utalk.setedup = 0; //Variable qui indique si le setup a été effectué
window.utalk.product = 0; // Produit actuel (0 par defaut)
window.utalk.playcanva = 0; // variable qui dis si on joue le canvas ou non
window.utalk.aosZ = 0; // Axe Z AOS
window.utalk.aosY = 0; // Axe Y AOS
window.utalk.aosX = 0; // Axe X AOS
window.utalk.triggeredclick = false; // Click sur le Enter experience
window.utalk.touchenabled = true; // Si AOS est utilisé ou le touch
window.utalk.connectionalive = 0; // check de la connection avec le checkcoalive du renderer
window.utalk.datajsoncmd = 0; // initialisation de DataJson pour le transfere des informations depuis le nodeJS
window.utalk.isreadingkmore = false; // Si l'utilisateur est entrain de lire le knowmore
window.utalk.islastreadingkmore = false; //Si l'utilisatuer lis le knowmore sur la dernière slide
window.utalk.isreadingkmoreAlreadyOpen = false; //determine si on est sur la slide du stick open cela veut dire que le knowMore est deja ouvert
window.utalk.scrolling = 0; // Scoll du knowmore
window.utalk.productcheck = false; // Check des produits
window.utalk.aosstate = ""; // Status de l'AOS initialisé
window.utalk.idle = true; // est ce qu'on utilise l'AOS


const views = {
  landing: animated(Landing),
  timeline: animated(Timeline),
}

const ViewContainer = ({ view, ...props }) => {
  const View = views[view]
  return <View {...props}></View>
}



const App = () => {


 // Set timeout values
 const timeout = 480 *60  *1000
 const promptTimeout = 15 *1000
 
 if (!window.utalk){
  window.utalk = new Object();
  window.utalk.idle = true
 }
 // Modal open state
 const [open, setOpen] = useState(false)

 // Time before idle
 const [remaining, setRemaining] = useState(0)
 const [showRemaining, setShowRemaining] = useState(0)

 const onPrompt = () => {
   // onPrompt will be called after the timeout value is reached
   // In this case 30 minutes. Here you can open your prompt. 
   // All events are disabled while the prompt is active. 
   // If the user wishes to stay active, call the `reset()` method.
   // You can get the remaining prompt time with the `getRemainingTime()` method,
   //console.log("---------------ON PROMPT --------------------")
   setOpen(true)
   setRemaining(promptTimeout)
 }
 
 const onIdle = () => {
   // onIdle will be called after the promptTimeout is reached.
   // In this case 30 seconds. Here you can close your prompt and 
   // perform what ever idle action you want such as log out your user.
   // Events will be rebound as long as `stopOnMount` is not set.
   //console.log("---------------ON IDLE --------------------")
   setOpen(false)
   setRemaining(0)
   window.location.reload(true);
 }
 
 const onActive = () => {
   // onActive will only be called if `reset()` is called while `isPrompted()` 
   // is true. Here you will also want to close your modal and perform
   // any active actions. 
   //console.log("---------------ON ACTIVE --------------------")
   setOpen(false)
   setRemaining(0)
 }

 const onAction = (event) => {
  // Do something when a user triggers a watched event
  //console.log("---------------ON ACTION --------------------",event)
  window.utalk.idle = false;
  activate()
}

 const {
  start,
  reset,
  activate,
  pause,
  resume,
  isIdle,
  isPrompted,
  isLeader,
  getTabId,
  getRemainingTime,
  getElapsedTime,
  getLastIdleTime,
  getLastActiveTime,
  getTotalIdleTime,
  getTotalActiveTime
} = useIdleTimer({
  onPrompt,
  onIdle,
  onActive,
  onAction,
  timeout,
  promptTimeout,
  events: [
    'mousemove',
    'keydown',
    'wheel',
    'DOMMouseScroll',
    'mousewheel',
    'mousedown',
    'touchstart',
    'touchmove',
    'MSPointerDown',
    'MSPointerMove',
    'visibilitychange'
  ],
  immediateEvents: [],
  debounce: 0,
  throttle: 0,
  eventsThrottle: 200,
  element: document,
  startOnMount: true,
  startManually: false,
  stopOnIdle: false,
  crossTab: false,
  name: 'idle-timer',
  syncTimers: 0,
  leaderElection: false
})

 const handleStillHere = () => {
   setShowRemaining(getRemainingTime() / 1000) 
   setOpen(false)
   activate()
 }
 const { currentView, isPortrait, isShort } = useApp()

 useLayoutEffect(() => {
   const interval = setInterval(() => {
      // console.log( Math.ceil(getRemainingTime() / 1000))
      if (window.utalk.idle || currentView === 'landing'){
        //console.log("ACTIVATE",currentView)
        window.utalk.idle = false;
        handleStillHere()
      }
     if (isPrompted()) {
      const rem = Math.ceil(getRemainingTime() / 1000)
      setRemaining(rem)
      setShowRemaining(rem)

     }
   }, 1000)
   return () => {
     clearInterval(interval)
   }
 }, [getRemainingTime, isPrompted,currentView])


 

  const viewTransition = useTransition(currentView, {
    from: { entering: 0 },
    enter: { entering: 100 },
    leave: { entering: 0 },
    config: { mass: 20, tension: 150, friction: 80 },
    immediate: currentView === 'landing',
    exitBeforeEnter: true,
    config: { duration: 1000 },
  })

  const fade = useSpring({
    opacity: open ? 1: 0,
    top: open ? "0%": "-3%",
    position: "absolute",
    width:"100%",
    textAlign:"center",
    marginTop:"20px",
    zIndex:100000,
    color:"#ee4422",
    fontSize:"120%",
    delay:open ? 1000: 0,
  })
//display: open ? 'block' : 'none'
  return (
    <Root>
      
      {(!isPortrait || currentView === 'landing') && (
        <BrandLogo currentView={currentView} isShort={isShort}></BrandLogo>
      )}
      
      {viewTransition((props, item) => (
        <ViewContainer {...props} view={item}></ViewContainer>
      ))}
      <LandscapeModal></LandscapeModal>
      <animated.div className='modal' style={fade}>
      <div>Logging you out in <div style={{width:"25px",display:"inline-block",fontWeight:600}}>{showRemaining}</div> seconds</div>
      
    </animated.div>
    </Root>
  )
}


export default App
